import React from 'react'
import breakfast_Menu from "../images/Break Fast.jpeg"
import indianmaincourse from "../images/Indian Main course & Biriyani.jpeg"
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import coffeemocktails from "../images/Coffee Mocktails.jpeg";
import biriyani from "../images/Chinese Main Course.jpeg";
import sandwich from "../images/Sandwich Chat.jpeg";
import starter from "../images/starter.jpeg";

function Menu() {
  return (
    <div>
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <Zoom>
                <img src={breakfast_Menu} className="card-img-top" alt="breakfast_Menu" />
              </Zoom>
            </div>
            <div className="col-md-4 mt-3">
              <Zoom>
                <img src={indianmaincourse} className="card-img-top" alt="indianmaincourse" />
              </Zoom>
            </div>

            <div className="col-md-4 mt-3">
              <Zoom>
                <img src={coffeemocktails} className="card-img-top" alt="coffeemocktails" />
              </Zoom>
            </div>
            <div className="col-md-4 mt-3">
              <Zoom>
                <img src={biriyani} className="card-img-top" alt="indianmain" />
              </Zoom>
            </div>
 <div className="col-md-4 mt-3">
              <Zoom>
                <img src={sandwich} className="card-img-top" alt="sandwich" />
              </Zoom>
            </div>

 <div className="col-md-4 mt-3">
              <Zoom>
                <img src={starter} className="card-img-top" alt="starter menu" />
              </Zoom>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu